import { render, staticRenderFns } from "./myDetailCharge.vue?vue&type=template&id=062be58b&scoped=true"
import script from "./myDetailCharge.vue?vue&type=script&lang=js"
export * from "./myDetailCharge.vue?vue&type=script&lang=js"
import style0 from "./myDetailCharge.vue?vue&type=style&index=0&id=062be58b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062be58b",
  null
  
)

export default component.exports